<template>
    <!-- <v-card color="grey lighten-2"> -->
    <!-- Container para Información: -->
    <v-container>
        <v-layout row justify-space-around>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                        <v-layout row>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold teal--text text--lighten-2"
                                >{{ $t('title')}}</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon color="teal lighten-1">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('btn-cerrar')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider class="teal lighten-1"></v-divider>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="mx-auto transparent" width="100%" elevation="0">
                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        {{ $t('p1')}}
                                        <p></p>
                                        <span style="color:rgb(80, 203, 196);">
                                            <ul>
                                                <span v-html="$t('list1') "></span>
                                            </ul>
                                        </span>
                                        <br />
                                        <span v-html="$t('p2')"></span>
                                    </v-card-text>

                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 md4>
                                                    <v-card
                                                        max-width="100%"
                                                        class="mx-auto"
                                                        @click="onRetroalimentacion360"
                                                    >
                                                        <v-img
                                                            src="@/assets/caracteristicas/ejecutivo1.png"
                                                            class="align-end"
                                                            width="100%"
                                                            gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                                        >
                                                            <v-container>
                                                                <v-layout row justify-center>
                                                                    <v-flex
                                                                        xs12
                                                                        class="text-center font-weight-bold subtitle-1 teal--text text--lighten-2"
                                                                    >{{ $t('feedback360')}}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </v-card>
                                                </v-flex>

                                                <v-flex xs12 md4>
                                                    <v-card
                                                        max-width="100%"
                                                        class="mx-auto"
                                                        @click="onEquiposDeTrabajo"
                                                    >
                                                        <v-img
                                                            src="@/assets/caracteristicas/reporteEquipo1.png"
                                                            class="align-end"
                                                            width="100%"
                                                            gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                                        >
                                                            <v-container>
                                                                <v-layout row justify-center>
                                                                    <v-flex
                                                                        xs12
                                                                        class="text-center font-weight-bold subtitle-1 teal--text text--lighten-2"
                                                                    >{{ $t('workTeams')}}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs12 md4>
                                                    <v-card
                                                        max-width="100%"
                                                        class="mx-auto"
                                                        @click="onInteligenciaEmocional"
                                                    >
                                                        <v-img
                                                            src="@/assets/caracteristicas/reporteIE1.png"
                                                            class="align-end"
                                                            width="100%"
                                                            gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                                                        >
                                                            <v-container>
                                                                <v-layout row justify-center>
                                                                    <v-flex
                                                                        xs12
                                                                        class="text-center font-weight-bold subtitle-1 teal--text text--lighten-2"
                                                                    >{{ $t('emotionalIntelligence')}}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-img>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- </v-card> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Caracteristicas',
    data() {
        return {
            reporteIE: [
                {
                    src: require('@/assets/caracteristicas/reporteIE1.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteIE1.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteIE2.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteIE2.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteIE3.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteIE3.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteIE4.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteIE4.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteIE5.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteIE5.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteIE6.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteIE6.png'
                }
            ],
            reporte360: [
                {
                    src: require('@/assets/caracteristicas/ejecutivo1.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/ejecutivo1.png'
                },
                {
                    src: require('@/assets/caracteristicas/ejecutivo2.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/ejecutivo2.png'
                },
                {
                    src: require('@/assets/caracteristicas/ejecutivo3.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/ejecutivo3.png'
                },
                {
                    src: require('@/assets/caracteristicas/ejecutivo4.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/ejecutivo4.png'
                },
                {
                    src: require('@/assets/caracteristicas/ejecutivo5.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/ejecutivo5.png'
                },
                {
                    src: require('@/assets/caracteristicas/ejecutivo6.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/ejecutivo6.png'
                }
            ],
            equipos: [
                {
                    src: require('@/assets/caracteristicas/reporteEquipo1.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteEquipo1.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteEquipo2.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteEquipo2.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteEquipo3.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteEquipo3.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteEquipo4.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteEquipo4.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteEquipo5.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteEquipo5.png'
                },
                {
                    src: require('@/assets/caracteristicas/reporteEquipo6.png'),
                    ref:
                        'https://www.retroalimentame.com.mx/img/nueva/reportes/reporteEquipo6.png'
                }
            ]
        };
    },
    created() {},
    methods: {
        onRetroalimentacion360() {
            window.open(
                'https://nueva.retroalimentame.com.mx/reportes/retro360.pdf'
            );
        },
        onEquiposDeTrabajo() {
            window.open(
                'https://nueva.retroalimentame.com.mx/reportes/equipos.pdf'
            );
        },
        onInteligenciaEmocional() {
            window.open('https://nueva.retroalimentame.com.mx/reportes/ie.pdf');
        },
        onClose() {
            this.showCaracteristicasTxt = false;
        }
    },
    computed: {
        ...mapGetters(['waitCursor']),
        showCaracteristicasTxt: {
            get() {
                return this.$store.getters.showCaracteristicasTxt;
            },
            set(showCaracteristicasTxt) {
                this.$store.dispatch(
                    'updateShowCaracteristicasTxt',
                    showCaracteristicasTxt
                );
            }
        }
    }
};
</script>

<i18n>
{
    "es": {
        "title": "Características Generales",
        "p1": "El sistema actual está parametrizado con 36 reactivos de opción múltiple y la siguiente escala para responder:",
        "list1": "<li>Totalmente de acuerdo</li><li>Parcialmente de acuerdo</li><li>Parcialmente en desacuerdo</li><li>Totalmente en desacuerdo</li>",
        "p2": "<p>Sin embargo y conforme los requerimientos de cada cliente, el sistema puede ser parametrizado tanto en la escala de respuestas (cinco opciones múltiples) como en el texto mismo de los reactivos en el que se pueden hacer ajustes menores.</p><p>El registro de la retroalimentación toma aproximadamente 20 minutos.</p><p>El sistema evalúa 12 competencias en una escala de 100 puntos. Cada competencia es retroalimentada con base en tres reactivos que se promedian para obtener la percepción total.</p><p>En <span style='color:rgb(80, 203, 196);'><b>TalentWise</b> </span> también realizamos los procesos de consultoría necesarios para adecuar nuestra herramienta a las competencias que cada organización tiene definidas. De forma tal que hoy día, nuestra herramienta es usada por varias organizaciones que al ingresar a la página trabajan sobre sus competencias corporativas.</p><p>Hemos hecho que la inclusión de su logotipo y otros elementos de personalización haga que la herramienta se sienta como 'hecha en casa'.</p><p>El sistema admite al final de la retroalimentación que el usuario haga comentarios sobre la persona que está retroalimentando. Estos cometarios pueden ser divididos en grupos tales como: comportamientos que quisiéramos seguir viendo, comportamientos que no quisiéramos ver en el ejecutivo, etc.</p><p>El sistema tiene opción de escoger idioma para la retroalimentación. Inglés, francés y portugués son idiomas que podemos usar a solicitud de nuestros clientes. Otros idiomas pueden ser incluidos en el sistema.</p><p>A continuación presentamos algunos ejemplos de nuestros reportes de retroalimentación individual y de equipos, así como de inteligencia emocional:</p>",
        "feedback360": "Retroalimentación 360°",
        "workTeams": "Equipos de trabajo",
        "emotionalIntelligence": "Inteligencia emocional"
    },
    
    "en": {
        "title": "General Characteristics",
        "p1": "The current system is parameterized with 36 multiple choice items and the following scale to answer:",
        "list1": "<li>Totally agree</li><li>Partially agree</li><li>Partially disagree</li><li>Strongly disagree</li>",
        "p2": "<p>However, and according to the requirements of each client, the system can be parameterized both on the scale of responses (five multiple options) and on the text of the items in which minor adjustments can be made.</p><p>Registering feedback takes approximately 20 minutes.</p><p>The system evaluates 12 competencies on a scale of 100 points. Each competition is fed back based on three items that are averaged to obtain total perception.</p><p>At <span style='color:rgb(80, 203, 196);'><b>TalentWise</b> </span> we also carry out the necessary consulting processes to adapt our tool to the competencies that each organization has defined. In such a way that today, our tool is used by several organizations that when entering the page work on their corporate competencies.</p><p>We've made the inclusion of your logo and other personalization elements make the tool feel 'home made'.</p><p>At the end of the feedback, the system allows the user to comment on the person who is feedback. These comments can be divided into groups such as: behaviors that we would like to continue seeing, behaviors that we do not want to see in the executive, etc.</p><p>The system has the option of choosing a language for feedback. English, French and Portuguese are languages ​​that we can use at the request of our clients. Other languages ​​can be included in the system.</p><p>Here are some examples of our individual and team feedback reports, as well as emotional intelligence:</p>",
        "feedback360": "360° Feedback",
        "workTeams": "Work teams",
        "emotionalIntelligence": "Emotional intelligence"
    }
}
</i18n>

<style scoped>
.sub-window {
    /* background: rgba(0, 77, 64, 0.6); */
    background: rgba(26, 32, 38, 0.84);
}
</style>